import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import { MyPromise } from '../interceptors/myPromise.service';
const LOGBOOKS_API_URL_PHP = `${environment.baseEndpointPHP}/logbooks`;
const INDICATORS_API_URL_PHP = `${environment.baseEndpointPHP}/indicators`;
const TEMPLATES_API_URL_PHP = `${environment.baseEndpointPHP}/logbook-templates`;

@Injectable({
  providedIn: 'root',
})

export class LogbookService {
  @Output() changeLogbookEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() changeEditLogbookEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() closeEditLogbookEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() editLogbookEvent: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) { }

  getIndicatorsStation(stationId: string, range: any, awaitTo = true) {
    const startDate = range.startDate.format('YYYY-MM-DD');
    const endDate = range.endDate.format('YYYY-MM-DD');
    if (awaitTo) {
      return this.myPromise.to(this.http.get(`${INDICATORS_API_URL_PHP}/station/${stationId}/logbooks`, { params: { startDate, endDate }}));
    }
    return this.myPromise.request(this.http.get(`${INDICATORS_API_URL_PHP}/station/${stationId}/logbooks`, { params: { startDate, endDate }}));
  }

  getLogbooks(stationId: string, type: number, range: any) {
    const startDate = range.startDate.format('YYYY-MM-DD');
    const endDate = range.endDate.format('YYYY-MM-DD');
    return this.myPromise.to(this.http.get(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/type/${type}`, { params: { startDate, endDate }}));
  }

  getLogbookAnnualProgramByIntervalDate(stationId: string, startDate: string, endDate: string) {
    return this.myPromise.to(this.http.get(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/annual-program`, {
      params: { startDate, endDate },
    })) as any;
  }

  store(stationId: string, logbook: any) {
    logbook.date = moment(logbook.date).format('YYYY-MM-DD');
    if (logbook.fields.date_realization) logbook.fields.date_realization = moment(logbook.fields.date_realization).format('YYYY-MM-DD');
    if (logbook.end_date) logbook.end_date = moment(logbook.end_date).format('YYYY-MM-DD');
    if (logbook.start_time.includes('m')) {
      logbook.start_time = moment(logbook.start_time, 'h:mm a').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'h:mm a').format('H:mm');
    } else {
      logbook.start_time = moment(logbook.start_time, 'HH:mm').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'HH:mm').format('H:mm');
    }
    return this.myPromise.to(this.http.post(`${LOGBOOKS_API_URL_PHP}/station/${stationId}`, logbook));
  }

  storeByProduct(stationId: string, logbook: any, data = { with_update: 0, column_field: '' }) {
    logbook.date = moment(logbook.date).format('YYYY-MM-DD');
    if (logbook.fields.date_realization) logbook.fields.date_realization = moment(logbook.fields.date_realization).format('YYYY-MM-DD');
    if (logbook.end_date) logbook.end_date = moment(logbook.end_date).format('YYYY-MM-DD');
    if (logbook.start_time.includes('m')) {
      logbook.start_time = moment(logbook.start_time, 'h:mm a').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'h:mm a').format('H:mm');
    } else {
      logbook.start_time = moment(logbook.start_time, 'HH:mm').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'HH:mm').format('H:mm');
    }
    return this.myPromise.to(this.http.post(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/product`, { ...logbook, ...data }));
  }

  storeByColumn(stationId: string, logbook: any, data = { column_field: '' }) {
    logbook.date = moment(logbook.date).format('YYYY-MM-DD');
    if (logbook.fields.date_realization) logbook.fields.date_realization = moment(logbook.fields.date_realization).format('YYYY-MM-DD');
    if (logbook.end_date) logbook.end_date = moment(logbook.end_date).format('YYYY-MM-DD');
    if (logbook.start_time.includes('m')) {
      logbook.start_time = moment(logbook.start_time, 'h:mm a').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'h:mm a').format('H:mm');
    } else {
      logbook.start_time = moment(logbook.start_time, 'HH:mm').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'HH:mm').format('H:mm');
    }
    return this.myPromise.to(this.http.post(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/column/type`, { ...logbook, ...data }));
  }

  update(logbookId: string, logbook: any) {
    logbook.date = moment(logbook.date).format('YYYY-MM-DD');
    if (logbook.fields.date_realization) logbook.fields.date_realization = moment(logbook.fields.date_realization).format('YYYY-MM-DD');
    if (logbook.end_date) logbook.end_date = moment(logbook.end_date).format('YYYY-MM-DD');
    if (logbook.start_time.includes('m')) {
      logbook.start_time = moment(logbook.start_time, 'h:mm a').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'h:mm a').format('H:mm');
    } else {
      logbook.start_time = moment(logbook.start_time, 'HH:mm').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'HH:mm').format('H:mm');
    }
    return this.myPromise.to(this.http.put(`${LOGBOOKS_API_URL_PHP}/${logbookId}`, logbook));
  }

  updateByProduct(logbookId: string, logbook: any, with_update = 0) {
    logbook.date = moment(logbook.date).format('YYYY-MM-DD');
    if (logbook.fields.date_realization) logbook.fields.date_realization = moment(logbook.fields.date_realization).format('YYYY-MM-DD');
    if (logbook.end_date) logbook.end_date = moment(logbook.end_date).format('YYYY-MM-DD');
    if (logbook.start_time.includes('m')) {
      logbook.start_time = moment(logbook.start_time, 'h:mm a').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'h:mm a').format('H:mm');
    } else {
      logbook.start_time = moment(logbook.start_time, 'HH:mm').format('H:mm');
      logbook.end_time = moment(logbook.end_time, 'HH:mm').format('H:mm');
    }
    return this.myPromise.to(this.http.put(`${LOGBOOKS_API_URL_PHP}/${logbookId}/product`, { ...logbook, with_update }));
  }

  updateUrlImage (logbookId: string, imgUrl: string, othersImages: any = []) {
    return this.myPromise.to(this.http.put(`${LOGBOOKS_API_URL_PHP}/${logbookId}/images`, {imgUrl, othersImages}));
  }

  getLastVolumeProduct(stationId: string, product: string, date: string, start_time: string) {
    return this.myPromise.to(this.http.get(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/product/${product}/last-volume/v2`, {
      params: {
        date: moment(date).format('YYYY-MM-DD'),
        start_time: moment(start_time, 'h:mm a').format('H:mm'),
      },
    }));
  }

  getNextVolumeProduct(stationId: string, product: string, date: string, start_time: string, logbook_id = 'na') {
    return this.myPromise.to(this.http.get(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/product/${product}/next-volume`, {
      params: {
        logbook_id,
        date: moment(date).format('YYYY-MM-DD'),
        start_time: moment(start_time, 'h:mm a').format('H:mm'),
      },
    }));
  }

  delete(id, with_update = 0) {
    return this.myPromise.to(this.http.delete(`${LOGBOOKS_API_URL_PHP}/${id}?with_update=${with_update}`));
  }

  folioNewAll(stationId: string, type: number, data: object) {
    return this.myPromise.to(this.http.post(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/type/${type}/folio/all`, data));
  }

  folioNewAllProduct(stationId: string, type: number, data: object) {
    return this.myPromise.to(this.http.post(`${LOGBOOKS_API_URL_PHP}/station/${stationId}/type/${type}/product/folio/all`, data));
  }

  exitCreateLogbook() {
    this.changeLogbookEvent.emit()
  }

  openEditLogbook() {
    this.changeEditLogbookEvent.emit()
  }

  exitEditLogbook() {
    this.closeEditLogbookEvent.emit()
  }

  sendDataToEditLogbook(data) {
    this.editLogbookEvent.emit(data)
  }

  storeTemplate(data, templateName) {
    const postData = {
      station_id: data.stationId,
      data,
      logbook_type: data.type,
      name: templateName,
    };

    return this.myPromise.to(this.http.post(`${TEMPLATES_API_URL_PHP}/station`, postData));
  }

  getTemplates(stationId: string, type: number) {
    return this.myPromise.to(this.http.get(`${TEMPLATES_API_URL_PHP}/station/${stationId}/${type}`));
  }

}
